import config from "config/config.js";
// import getFreshToken from "util/xsrfToken.js";

const getTicketsType = (id) => {
  const endpoint = `${config.baseUrl}/biglietti-eventis/tickets/${id}`;

  // const endpoint = `${config.baseUrl}/api/delivery/${MUSEUM_ID}`;
  const options = {
    method: "GET",
    mode: "cors",
    // headers: {
    // "Access-Control-Allow-Origin": `${config.baseUrl}`,
    // "Access-Control-Allow-Credentials": true,
    // Accept: "application/json",
    // "Content-Type": "application/json"
    // "X-XSRF-TOKEN": xsrfToken
    // }
    // credentials: "include"
  };
  // console.log("getMuseum endpoint", endpoint);

  return fetch(endpoint, options)
    .then((response) => {
      return response.json();
    })
    .then((res) => {
      // console.log("response getEventi", res);
      if (res) {
        return res;
      }
      return null;
    })
    .catch((e) => {
      // console.log("response getMuseum error", e);

      // eslint-disable-next-line no-console
      // console.log("error on retrieve ticket on event", e);
      return e;
    });
};

export default getTicketsType;
